export default __webpack_public_path__ + "static/media/No48Open.26d01f30.jpg";